import { styled } from '@mui/material/styles';

import Box from '@mui/material/Box';

export const RootContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  gap: '20px',
});

export const InfoContainer = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.primary.main}`,
  padding: '16px',
  borderRadius: '8px',
}));
